export default "__VITE_ASSET__BvW6NOHz__"